import useFormatNumber, { percentFormat } from '@/utils/hooks/format/useFormatNumber';
import useUser from '@/utils/hooks/swr/useUser';

const useFormatGraphData = () => {
    const { user } = useUser({ revalidateOnMount: false, revalidateOnFocus: false });
    const { formatNumber } = useFormatNumber(user?.settings?.numbers_format ?? 'comma');

    const findLastIndex = (graphData, key) => {
        const index = graphData
            .slice()
            .reverse()
            .findIndex((x) => x[key]);
        const count = graphData.length - 1;
        return index >= 0 ? count - index : index;
    };

    const formatNullValue = (data) => {
        let finalData = [];

        data.forEach((item) => {
            finalData.push({
                ...item,
                value: !item.value && !item.no_data ? 0 : item.value
            });
        });

        return finalData;
    };

    const formatEvolutionPercentValue = (value, avg) => {
        if (avg !== 0) {
            return formatNumber(((value * 100) / avg - 100) / 100, {
                ...percentFormat,
                signDisplay: 'always'
            });
        } else {
            return '0%';
        }
    };

    const formatPercentValue = (value, graphData) => {
        let total = 0;

        if (graphData.length > 1) {
            Object.values(graphData).map(({ value }) => (total += value));
        } else {
            Object.values(graphData[0]).map((singleValue) => (total += singleValue));
        }

        if (total > 0) {
            return formatNumber((value * 100) / total / 100, percentFormat);
        }
        return total;
    };

    const formatNoDataArea = (graphData) => {
        const previousIndex = graphData.findIndex((item) => item.no_data) - 1;
        const nextIndex = findLastIndex(graphData, 'no_data') + 1;

        return { x1: graphData[previousIndex]?.date, x2: graphData[nextIndex]?.date };
    };

    return {
        formatNullValue,
        formatPercentValue,
        formatEvolutionPercentValue,
        formatNoDataArea
    };
};

export default useFormatGraphData;
